import { observer } from "mobx-react-lite";
import type { FC } from "react";
import { useParams } from "react-router-dom";
import { useServiceFactory } from "../../app/appServices";
import { Status } from "../../components/status/status";
import { ErrorState } from "../../helpers/error";
import { useMount } from "../../helpers/reactHooks";
import { Form } from "./components/form/form";

export const PaymentLink: FC = observer(() => {
  const store = useServiceFactory((x) => x.createPaymentLinkStore());
  const params = useParams();
  const { paymentTemplateId, productId } = params;

  useMount(async () => {
    await store.load(paymentTemplateId, productId);
  });

  if (store.state === "loading") {
    return <Status type="progress" />;
  }

  if (store.state instanceof ErrorState) {
    return <Status type="error" title="We ran into some problems..." text={store.state.message} />;
  }

  return <Form template={store.state} />;
});
